'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = {
  transform: 'scale(0.5, 0.5)'
};

function CategoryIcon(_ref) {
  var category = _ref.category,
      status = _ref.status,
      width = _ref.width,
      height = _ref.height;

  function backgroundClass() {
    var color = 'gray';

    switch (status) {
      case 'hover':
        color = 'darkgray';
        break;

      case 'selected':
        color = 'white';
        break;
    }

    return 'cat-icon-' + category + '-' + color;
  }

  return _react2["default"].createElement('div', {
    className: 'Icon ' + backgroundClass(),
    style: styles
  });
}

var component = (0, _radium2["default"])(CategoryIcon);
exports["default"] = {
  component: component
};